var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showCondition,
            expression: "showCondition"
          }
        ],
        staticClass: "el-icon-caret-top",
        on: {
          click: function($event) {
            _vm.showCondition = false
          }
        }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showCondition,
              expression: "showCondition"
            }
          ],
          staticStyle: { display: "flex", "margin-top": "5px" }
        },
        [
          _vm.conditionItems.length > 0
            ? _c(
                "el-form",
                {
                  staticStyle: { "flex-grow": "1" },
                  attrs: { inline: true, "label-width": "100px" }
                },
                _vm._l(_vm.conditionItems, function(item, index) {
                  return _c("condition-form-item", {
                    key: index,
                    attrs: {
                      item: item,
                      "descriptor-registry": _vm.descriptorRegistry
                    }
                  })
                }),
                1
              )
            : _c("div", { staticStyle: { "flex-grow": "1" } }),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                "justify-content": "space-between",
                "align-items": "flex-end"
              }
            },
            [
              _vm.lastUpdateTime
                ? _c(
                    "span",
                    {
                      staticClass: "el-form-item__label",
                      staticStyle: { color: "#000000" }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_LastUpdateTime")) +
                          ": " +
                          _vm._s(_vm.lastUpdateTime)
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  style:
                    (_vm.isZh ? "width: 240px;" : "width: 310px;") +
                    "display: flex;flex-direction: row-reverse;flex-shrink: 0;align-items: flex-end;padding-bottom: 7px;"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "Back", type: "primary" },
                      on: { click: _vm.backToOldVersion }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_BackTopPreviousVersion"))
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { no: "DataExport", type: "primary" },
                      on: { click: _vm.exportHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DataExport")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "5px" },
                      attrs: { no: "Query", type: "primary" },
                      on: { click: _vm.toQuery }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("i", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.showCondition,
            expression: "!showCondition"
          }
        ],
        staticClass: "el-icon-caret-bottom",
        on: {
          click: function($event) {
            _vm.showCondition = true
          }
        }
      }),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "column",
            "flex-grow": "1",
            background: "white"
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.firstPage,
                  expression: "!firstPage"
                }
              ],
              staticStyle: { "margin-top": "5px" }
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "Cargo_Back", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.firstPage = true
                      _vm.report.heightChangeFlag = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Back")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "SaveDisplayColumns", type: "primary" },
                  on: { click: _vm.saveDisplayColumns }
                },
                [_vm._v(_vm._s(_vm.$t("Message.SaveDisplayColumns")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "Setting", type: "primary" },
                  on: { click: _vm.toConfigColumns }
                },
                [_vm._v(_vm._s(_vm.$t("Pricing.Setting")))]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                flex: "1",
                position: "relative",
                "margin-top": "5px"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    width: "100%",
                    height: "100%"
                  }
                },
                [
                  _vm.dwReportVersion === 1
                    ? [
                        _vm.firstPage && _vm.report.headers.length > 0
                          ? _c("dw-ag-grid", {
                              key: "dwReport",
                              ref: "dwReport",
                              attrs: {
                                "config-module": _vm.reportConfigModule,
                                headers: _vm.reportHeaders,
                                "row-data": _vm.report.rowData,
                                "filter-menu-items": _vm.filterMenuItems
                              },
                              on: { cellClick: _vm.onCellClick }
                            })
                          : _vm._e(),
                        !_vm.firstPage && _vm.reportDetail.headers.length > 0
                          ? _c("dw-ag-grid", {
                              key: "dwReportDetail",
                              ref: "dwReportDetail",
                              attrs: {
                                "config-module": _vm.reportDetailConfigModule,
                                headers: _vm.reportDetail.headers,
                                "row-data": _vm.reportDetail.rowData,
                                "cell-class-name": _vm.onDetailCellClassName,
                                "sub-sum-disiplay-all": false,
                                "filter-menu-items": _vm.filterMenuItems
                              },
                              on: { cellClick: _vm.onDetailCellClick }
                            })
                          : _vm._e()
                      ]
                    : [
                        _c("dw-report", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.firstPage && _vm.report.headers.length > 0,
                              expression: "firstPage&&report.headers.length>0"
                            }
                          ],
                          ref: "dwReport",
                          attrs: {
                            headers: _vm.reportHeaders,
                            "row-data": _vm.report.rowData,
                            "height-change-flag": _vm.report.heightChangeFlag
                          },
                          on: {
                            "update:heightChangeFlag": function($event) {
                              return _vm.$set(
                                _vm.report,
                                "heightChangeFlag",
                                $event
                              )
                            },
                            "update:height-change-flag": function($event) {
                              return _vm.$set(
                                _vm.report,
                                "heightChangeFlag",
                                $event
                              )
                            },
                            cellClick: _vm.onCellClick
                          }
                        }),
                        _c("dw-report", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !_vm.firstPage &&
                                _vm.reportDetail.headers.length > 0,
                              expression:
                                "!firstPage&&reportDetail.headers.length>0"
                            }
                          ],
                          ref: "dwReportDetail",
                          attrs: {
                            headers: _vm.reportDetail.headers,
                            "row-data": _vm.reportDetail.rowData,
                            "cell-class-name": _vm.onDetailCellClassName,
                            "sub-sum-disiplay-all": false,
                            "height-change-flag":
                              _vm.reportDetail.heightChangeFlag
                          },
                          on: {
                            "update:heightChangeFlag": function($event) {
                              return _vm.$set(
                                _vm.reportDetail,
                                "heightChangeFlag",
                                $event
                              )
                            },
                            "update:height-change-flag": function($event) {
                              return _vm.$set(
                                _vm.reportDetail,
                                "heightChangeFlag",
                                $event
                              )
                            },
                            cellClick: _vm.onDetailCellClick
                          }
                        })
                      ]
                ],
                2
              )
            ]
          )
        ]
      ),
      _c(
        "form",
        {
          ref: "form",
          staticStyle: { display: "none" },
          attrs: { action: _vm.fileUrl, target: "_blank", method: "post" }
        },
        _vm._l(_vm.fileFormEntries, function(item) {
          return _c("input", {
            key: item[0],
            attrs: { name: item[0] },
            domProps: { value: item[1] }
          })
        }),
        0
      ),
      _c("export-operation-dialog", {
        attrs: {
          visible: _vm.exportOperationDialog.visible,
          prefix: _vm.exportOperationDialogPrefix
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.exportOperationDialog, "visible", $event)
          },
          export: function($event) {
            return _vm.doExport()
          }
        }
      }),
      _c("column-config-dialog", {
        attrs: {
          visible: _vm.columnConfigDialog.visible,
          "descriptor-registry": _vm.descriptorRegistry,
          "report-id": _vm.reportId,
          "fact-table-id": _vm.columnConfigDialog.factTableId,
          "fact-table-column-id": _vm.columnConfigDialog.factTableColumnId,
          "fact-table-number": _vm.columnConfigDialog.factTableNumber
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.columnConfigDialog, "visible", $event)
          },
          enter: _vm.showReportDetail
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }